<script lang="ts">
    import type {Document} from 'src/typings';
    import {KpMasonryGrid, KpMasonryGridItem} from 'shared/layouts';
    import KpRecordTile from './KpRecordTile.svelte';

    export let records: Document[];
</script>

<KpMasonryGrid>
    {#each records as record(record.id)}
        <KpMasonryGridItem>
            <KpRecordTile {record}/>
        </KpMasonryGridItem>
    {/each}
</KpMasonryGrid>